import ResumeVideoCard from './resume-video-card'

export default ResumeVideoCard